import {
  FaUser,
  FaBriefcase,
  FaLayerGroup,
  FaGraduationCap,
  FaFilePdf,
  FaEnvelope,
  FaTerminal,
  FaMusic,
  FaCompactDisc,
} from "react-icons/fa6";
import type { AppConfig } from "./types";
import { colors } from "./theme";
import AboutApp from "./apps/AboutApp";
import ExperienceApp from "./apps/ExperienceApp";
import SkillsApp from "./apps/SkillsApp";
import EducationApp from "./apps/EducationApp";
import ResumeApp from "./apps/ResumeApp";
import ContactApp from "./apps/ContactApp";
import TerminalApp from "./apps/TerminalApp";
import MusicApp from "./apps/MusicApp";
import ScreensaverApp from "./apps/ScreensaverApp";

export const apps: AppConfig[] = [
  {
    id: "about",
    title: "About Me",
    icon: FaUser,
    accent: colors.green,
    component: AboutApp,
    defaultSize: { width: 600, height: 620 },
    pinned: true,
    desktop: true,
    openOnBoot: true,
  },
  {
    id: "experience",
    title: "Experience",
    icon: FaBriefcase,
    accent: colors.peach,
    component: ExperienceApp,
    defaultSize: { width: 660, height: 580 },
    pinned: true,
    desktop: true,
  },
  {
    id: "skills",
    title: "Tech Stack",
    icon: FaLayerGroup,
    accent: colors.sky,
    component: SkillsApp,
    defaultSize: { width: 720, height: 580 },
    pinned: true,
    desktop: true,
  },
  {
    id: "education",
    title: "Education",
    icon: FaGraduationCap,
    accent: colors.lilac,
    component: EducationApp,
    defaultSize: { width: 580, height: 500 },
    desktop: true,
  },
  {
    id: "resume",
    title: "Resume",
    icon: FaFilePdf,
    accent: colors.red,
    component: ResumeApp,
    defaultSize: { width: 720, height: 700 },
    pinned: true,
    desktop: true,
  },
  {
    id: "contact",
    title: "Contact",
    icon: FaEnvelope,
    accent: colors.purple,
    component: ContactApp,
    defaultSize: { width: 480, height: 440 },
    pinned: true,
    desktop: true,
  },
  {
    id: "terminal",
    title: "Terminal",
    icon: FaTerminal,
    accent: colors.ink,
    component: TerminalApp,
    defaultSize: { width: 560, height: 360 },
    desktop: true,
  },
  {
    id: "music",
    title: "Music",
    icon: FaMusic,
    accent: colors.butter,
    component: MusicApp,
    defaultSize: { width: 360, height: 460 },
    pinned: true,
    desktop: true,
    easterEgg: true,
  },
  {
    id: "screensaver",
    title: "Screensaver",
    icon: FaCompactDisc,
    accent: colors.orange,
    component: ScreensaverApp,
    defaultSize: { width: 540, height: 380 },
    desktop: true,
    easterEgg: true,
  },
];
